export interface ProductsListCellItem {
    id: string;
    productName: string;
    description: string;
    ulogin: string;
    newDescription: string;
    isEdited: boolean;
}

export const PRODUCTS_PREFIX = 'products';

export interface Products {
    products: ProductsListCellItem[];
    filtered: ProductsListCellItem[];
    pageStatus: ProductsPageStates;
    productsForm: ProductsForm;
    isFiltered: boolean;
}

export interface Product {
    id: string;
    productName: string;
    description: string;
    ulogin: string;
}

export enum ProductsPageStates {
    PENDING = 'PENDING',
    FETCH_FORM = 'FETCH_FORM',
    LOADING = 'LOADING',
    LOADED = 'LOADED',
    ERROR = 'ERROR',
    ACTION = 'ACTION'
}

export interface ProductsForm {
    product: NewProduct;
    isEnabled: boolean;
    isValid: boolean;
}

export interface NewProduct {
    productName: string;
    description: string;
}

export interface ServerProduct {
    productId: number;
    productName: string;
    productDescription: string;
    productLogin: string;
}
